import api from "./axios";
import log from "../utils/log";

export const getUnsubscribeList = async () => {
  try {
    const response = await api.get(`api/v1/customer/unsubscribe`);
    return response.data;
  } catch (error) {
    log.error(
      error.response?.data?.message ||
        "Failed to update email. Please try again."
    );
    return null;
  }
};

export const unSubscribeEmail = async data => {
  try {
    const response = await api.post(`/api/v1/customer/unsubscribe`, data);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong");
  }
};

export const cancelAutoRenew = async () => {
  try {
    const response = await api.post(`/api/v1/customer/subscription/cancel-auto-renew`);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong");
  }
};

export const resumeAutoRenew = async () => {
  try {
    const response = await api.post(`/api/v1/customer/subscription/resume-auto-renew`);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong");
  }
};